module.exports = __webpack_public_path__ + "static/media/HM.83e7090b.png";